<button id="export" type="button" class="btn btn-primary" (click)="export()">
	{{'general.export' | translate}}
</button>
